import qs from "query-string";
const setQueryStringWithoutPageReload = (qsValue: string) => { 
  const newurl = window.location.protocol + "//" +
                 window.location.host + 
                 window.location.pathname + 
                 qsValue;

  window.history.pushState({ path: newurl }, "", newurl);
};

export const setQueryStringValue = (key: string, value: string,  queryString = window.location.search) => { 
   const values = qs.parse(queryString); 
   const newQsValue = qs.stringify({ ...values, [key]: value });
   setQueryStringWithoutPageReload(`?${newQsValue}`);
};

export const getQueryStringValue: (key: string, queryString?: string) => string | undefined = (key, queryString = window.location.search) => {
  const values = qs.parse(queryString);
  return values[key] as string;
};

export const getQueryString = (queryString = window.location.search) => {
  return qs.parse(queryString);
};

export const getQS = getQueryString;

// Removes one or more query keys from the current URL without reloading.
// Preserves protocol, host, pathname, and hash.
export const removeQueryKeysWithoutReload = (keys: string | string[]) => {
    const toDelete = Array.isArray(keys) ? keys : [keys];

    const url = new URL(window.location.href);

    // Delete specified keys (handles duplicates automatically)
    for (const k of toDelete) {
        url.searchParams.delete(k);
    }

    // If no search params left, ensure clean URL (URL handles this itself)
    // Push updated URL to history without page reload
    window.history.pushState({ path: url.toString() }, "", url.toString());
};
